export const OPEN_NOT_FROM_EMAIL_SEARCH_PARAM: string = 'open_not_from_email';
export const OPEN_NOT_FROM_EMAIL_SEARCH_PARAM_YES_VALUE: string = 'yes';